module.exports = __webpack_public_path__ + "firasans-light-webfont.03ef75f7c88d99734a3b.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/sherr/Desktop/bsf-website/src/assets/fonts/firasans-light-webfont.woff
// module id = ../../../../../src/assets/fonts/firasans-light-webfont.woff
// module chunks = 1